import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { ApiResponse } from '../models/apiResponse';
import { PageMeta, PageTitle } from '../models/page-meta';
import { GlobalComponent } from '../global-component';
import { Blog, SiteInfo } from '../models/blog';
import { SubscriberModel } from '../models/subscriberModel';
import { SKIP_API_CACHE } from './cache-http.interceptor';
import { ContactModel } from '../models/contact';

const baseUrl = GlobalComponent.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class PagesApiService {
  constructor(
    private httpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  getPageTitles(isActive: number): Observable<ApiResponse<PageTitle[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<PageTitle[]>>(
        baseUrl + '/pagemeta/GetPageBannerTitles?isActive=' + isActive
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<PageTitle[]>);
  }

  getPagesMeta(): Observable<ApiResponse<PageMeta[]>> {
    return this.httpClient.get<ApiResponse<PageMeta[]>>(
      baseUrl + '/pagemeta/GetUIPages'
    );
  }

  getSiteInfo(): Observable<ApiResponse<SiteInfo[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<SiteInfo[]>>(
        `${baseUrl}/SiteInfo/GetSiteInfos?isActive=1`
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<SiteInfo[]>);
  }

  getSocialMediaUrls(): Observable<ApiResponse<SiteInfo[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<SiteInfo[]>>(
        `${baseUrl}/SiteInfo/GetUISocialMediaData`
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<SiteInfo[]>);
  }

  getBlogs(isActive: number): Observable<ApiResponse<Blog[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<Blog[]>>(
        `${baseUrl}/Blogs/GetUIblogs?IsActive=${isActive}`
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<Blog[]>);
  }

  postSubscriber(
    subscriber: SubscriberModel
  ): Observable<ApiResponse<SubscriberModel>> {
    return this.httpClient.post<ApiResponse<SubscriberModel>>(
      baseUrl + '/users/Addsubscriber',
      subscriber,
      { context: new HttpContext().set(SKIP_API_CACHE, true) }
    );
  }

  postContact(contact: ContactModel): Observable<ApiResponse<ContactModel>> {
    return this.httpClient.post<ApiResponse<ContactModel>>(
      baseUrl + '/users/SaveNSendEmail',
      contact,
      { context: new HttpContext().set(SKIP_API_CACHE, true) }
    );
  }
}
